<div class="metabase-frame-container">
    <iframe 
        [src]="iframeUrl | safeUrl: 'resourceUrl'" 
        width="100%" 
        height="600px" 
        frameborder="0"
        allowfullscreen>
    </iframe>
</div>